export default __webpack_public_path__ + "static/media/hbse.c3bc3624.png";